<!-- 组件说明 -->
<template>
  <div class="">
    <!-- 数据选择模块 -->
    <div class="date-select">
      <div class="deadline">数据截止{{ Data_end_time }}</div>
      <div>
        <van-popover
          v-model="showPopover"
          trigger="click"
          :actions="actionSelect"
          @select="onSelect"
          placement="bottom-end"
        >
          <template #reference>
            <div class="to-year">
              <span> {{ toYear }}年 </span>
              <van-icon
                name="play"
                :class="['icon-arrow', showPopover ? ' active' : '']"
              />
            </div>
          </template>
        </van-popover>
      </div>
    </div>
    <!-- 认购套数模块 -->
    <buy-num :toYear="toYear" :statisticsData="statisticsData" />
    <!-- 认购占比模块 -->
    <buy-ratio :toYear="toYear" :statisticsData="statisticsData" />
    <!-- 图表模块 -->
    <div class="seleted-ratio">
      <span
        :class="['slider', status === 3 ? 'slider-selecter' : '']"
        @click="status = 3"
        >认购</span
      >
      <span
        :class="['slider', status === 2 ? 'slider-selecter' : '']"
        @click="status = 2"
        >签约</span
      >
    </div>
    <sale-echarts :allStatusStatistical="allStatusStatistical" />
    <!-- 本月本年数据 -->
    <to-year-num :projectCode="projectCode" :orgCode="orgCode" />
    <!-- loading -->
    <!-- <loading :show="loadingStatus"></loading> -->
  </div>
</template>

<script>
import loading from "@/components/loading";
import { Popover as VanPopover, Icon as VanIcon } from "vant";
import BuyNum from "./DataDisplayComponent/BuyNum";
import BuyRatio from "./DataDisplayComponent/BuyRatio";
import SaleEcharts from "./DataDisplayComponent/SaleEcharts";
import ToYearNum from "./DataDisplayComponent/ToYearNum";
import moment from "moment";
export default {
  components: {
    VanPopover,
    VanIcon,
    BuyNum,
    BuyRatio,
    SaleEcharts,
    ToYearNum,
    // loading,
  },
  props: ["projectCode", "orgCode"],
  data() {
    return {
      // 加载中
      loadingStatus: false,
      showPopover: false,
      Data_end_time: "",
      actions: [
        { text: moment().format("YYYY") },
        { text: moment().format("YYYY") - 1 },
      ],
      toYear: moment().format("YYYY"),
      status: 3,
      // 城市和项目ID
      userCode: {
        projectCode: this.projectCode,
        orgCode: this.orgCode,
      },
      // 认购签约统计
      statisticsData: {
        subscribeTotal: 0,
        signingTotal: 0,
        ldxSubscribeTotal: 0,
        ldxSigningTotal: 0,
        ldxSubscribePercentage: 0,
        ldxSigningPercentage: 0,
      },
      // ercharts源数据
      allStatusStatistical: [],
    };
  },
  computed: {
    actionSelect() {
      return [...this.actions].map((res) => {
        if (res.text == this.toYear) {
          res.className = "action-selected";
        } else {
          res.className = "";
        }
        return res;
      });
    },
  },
  methods: {
    onSelect(val) {
      this.toYear = val.text + "";
    },
    // 认购签约统计
    dataShowStatistic() {
      let params = Object.assign({}, this.userCode, { year: this.toYear });
      this.$api.dataShowStatistic(params).then((res) => {
        if (res.body.length) {
          this.statisticsData = res.body[0];
          let _data = JSON.parse(JSON.stringify(this.statisticsData));
          this.Data_end_time = moment(_data.DataEndTme).format(
            "YYYY年MM月DD日 HH:mm"
          );

          this.$forceUpdate();
        } else {
          this.statisticsData = {
            subscribeTotal: 0,
            signingTotal: 0,
            ldxSubscribeTotal: 0,
            ldxSigningTotal: 0,
            ldxSubscribePercentage: 0,
            ldxSigningPercentage: 0,
          };
        }
      });
    },
    // 认购签约列表
    dataShowList() {
      let params = Object.assign({}, this.userCode, {
        year: this.toYear,
        status: this.status,
      });
      this.$api
        .dataShowList(params)
        .then((res) => {
          if (res.status && res.code === "0000") {
            this.allStatusStatistical = res.body;
            //  this.loadingStatus = false;
          } else {
            this.allStatusStatistical = [];
            //  this.loadingStatus = false;
          }
        })
        .catch(() => {
          // this.loadingStatus = false;
        });
    },
  },
  created() {
    // this.loadingStatus = true;
    this.dataShowStatistic();
    this.dataShowList();
  },
  watch: {
    // 监听项目变化刷新页面
    projectCode(val) {
      this.userCode.projectCode = val;
      this.userCode.orgCode = this.orgCode;
      this.dataShowStatistic();
      this.dataShowList();
    },
    // 年份变化刷新页面
    toYear() {
      this.dataShowStatistic();
      this.dataShowList();
    },
    // 认购签约状态变化刷新页面
    status() {
      this.dataShowList();
    },
  },
};
</script>

<style lang="scss">
.action-selected {
  color: #0d9869;
}
</style>
<style lang="scss" scoped>
.date-select {
  display: flex;
  justify-content: space-between;
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 24px;
  font-weight: 400;

  .deadline {
    color: #0f4432;
  }
  .to-year {
    color: #333333;
    .icon-arrow {
      transform: rotate(90deg);
    }
    .icon-arrow.active {
      transform: rotate(-90deg);
      color: #0d9869;
    }
  }
}
.seleted-ratio {
  width: 236px;
  height: 70px;
  background: #ffffff;
  border-radius: 12px;
  border: 2px solid #eeeeee;
  margin: 36px auto 0;
  padding: 6px;
  .slider {
    width: 106px;
    height: 50px;
    border-radius: 12px;
    display: inline-block;
    text-align: center;
    line-height: 50px;
    font-size: 28px;
    color: #0d9869;
    font-family: PingFangSC-Regular, PingFang SC;
    &.slider-selecter {
      background: #0d9869;
      box-shadow: 0px 0px 4px 0px rgba(13, 152, 105, 0.4);
      color: #ffffff;
    }
  }
}
</style>
